
import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator'
import { Job } from '../../global/models'

@Component
export default class JobForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  private readonly value!: Partial<Job>

  job: Partial<Job> = {}

  @Watch('value', { immediate: true })
  private valueChanged(val: Job) {
    this.job = { ...val }
  }
}
